import script from "./BusinessProcessActivityTimeline.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessProcessActivityTimeline.vue?vue&type=script&setup=true&lang=js"

import "./BusinessProcessActivityTimeline.vue?vue&type=style&index=0&id=b674aed2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b674aed2"]])

export default __exports__